import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-394a2d1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Handlingslistor")
], -1))
const _hoisted_4 = { class: "col-2 text-end" }
const _hoisted_5 = {
  class: "btn btn-link btn-lg",
  title: "Skapa ny handlingslista"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  class: "table table-striped table-hover",
  id: "shopping-list-table"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Namn"),
    /*#__PURE__*/_createElementVNode("th", null, "Skapad"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-center"
}, "Laddar...", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-center"
}, " Här var det tomt... Skapa en ny lista genom att trycka på plus-knappen ovan! ↗ ", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "btn btn-link btn-sm" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Redan skickade")
], -1))
const _hoisted_19 = { class: "row" }
const _hoisted_20 = {
  key: 0,
  class: "table table-striped table-hover",
  id: "order-table"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Namn"),
    /*#__PURE__*/_createElementVNode("th", null, "Inskickad"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-center"
}, "Laddar...", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "text-center"
}, "Här var det tomt...", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, { to: { name: 'create-shopping-list' } }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_5, [
              _createVNode(_component_fa_icon, { icon: "plus-circle" })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("tbody", null, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.shoppingLists.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shoppingLists, (shoppingList) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: shoppingList.id
            }, [
              _createElementVNode("td", {
                onClick: ($event: any) => (_ctx.viewShoppingList(shoppingList)),
                class: "pointer"
              }, _toDisplayString(shoppingList.name), 9, _hoisted_15),
              _createElementVNode("td", {
                onClick: ($event: any) => (_ctx.viewShoppingList(shoppingList)),
                class: "pointer"
              }, _toDisplayString(shoppingList.createdAt.format("YYYY-MM-DD")), 9, _hoisted_16),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  title: "Kasta handlingslista",
                  to: {
                  name: 'delete-shopping-list',
                  params: { id: shoppingList.id },
                }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_17, [
                      _createVNode(_component_fa_icon, { icon: "trash-alt" })
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      (_ctx.orders)
        ? (_openBlock(), _createElementBlock("table", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("tbody", null, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, _hoisted_24))
                : _createCommentVNode("", true),
              (!_ctx.loading && _ctx.orders.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, _hoisted_27))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: order.id
                }, [
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.viewOrder(order)),
                    class: "pointer"
                  }, _toDisplayString(order.shoppingList?.name), 9, _hoisted_28),
                  _createElementVNode("td", {
                    onClick: ($event: any) => (_ctx.viewOrder(order)),
                    class: "pointer"
                  }, _toDisplayString(order.submittedAt.format("YYYY-MM-DD")), 9, _hoisted_29),
                  _createElementVNode("td", null, [
                    _createVNode(_component_router_link, {
                      title: "Kopiera handlingslistan",
                      to: {
                  name: 'create-shopping-list',
                  query: { sourceShoppingList: order.shoppingList?.id },
                  params: { shoppingList: order.shoppingList },
                }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_fa_icon, { icon: "copy" })
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}